import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { connect } from 'react-redux';
import { MODAL_CARD_FORM, showModal } from '../../../../modules/modals';
import './style.scss';
import Item from './components/Item/Item'
import { List } from 'antd';
import { Pagination } from 'antd';
import {cloneDeep, difference, isEqual} from 'lodash';

export class Cards extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
    console.log("🚀 ~ file: Cards.jsx ~ line 17 ~ Cards ~ constructor ~ props.cards", props)
		super(props)
		this.state = {
			cards_data: props.cards,
			pageSize: 10,
			currentPage: 1,
			cards: this.paginate(props.cards, 10, 1),
		}

		this.refEndEl = React.createRef();
	}

  scrollToBottom = () => {
		if(this.refEndEl.current){
			this.refEndEl.current.scrollIntoView({ behavior: "smooth" });
		}
	}

	componentDidMount(){
		window.goToLastPage = this.goToLastPage;

	}

	goToLastPage = () => {
		let {currentPage} = this.state;
		currentPage = Math.ceil(this.props.cards.length/this.state.pageSize);
		this.setState({
			cards_data: this.props.cards,
			cards: this.paginate(this.props.cards, this.state.pageSize, currentPage),
			currentPage
		});
		this.scrollToBottom();
	}


	componentWillReceiveProps(nextProps){

		const newIds = nextProps.cards.map(i => i.id);
		const oldIds = this.state.cards_data.map(i => i.id);
		let {currentPage} = this.state;
    if(!isEqual(newIds, oldIds)){
      console.log('test+++')
      this.setState({
        cards_data: nextProps.cards,
        cards: this.paginate(nextProps.cards, this.state.pageSize, currentPage),
      })
    } else {
      this.setState({
        cards_data: nextProps.cards,
        cards: this.state.cards.map(_i => {
          const find = nextProps.cards.find(_f => _i.id == _f.id);
          return find ? {...find} : {..._i}
        })
      })
    }
	}

	onShowSizeChange = (current, pageSize) => {
		this.setState({
			cards: this.paginate(this.state.cards_data, pageSize, current),
			pageSize,
			currentPage: current
		})
	}

	paginate = (array, page_size, page_number) => {
		if(page_number == 0){
			return cloneDeep(array).slice(0, page_size);
		}
  	--page_number;
		return cloneDeep(array).slice(page_number * page_size, (page_number + 1) * page_size);
	}

	scrollToTop(scrollDuration) {
    var scrollStep = -window.scrollY / (scrollDuration / 15),
        scrollInterval = setInterval(function(){
        if ( window.scrollY != 0 ) {
            window.scrollBy( 0, scrollStep );
        }
        else clearInterval(scrollInterval); 
    },15);
	}

  render() {
    const {formatMessage} = this.context;
    const {cards, cards_data, pageSize, currentPage } = this.state;
    return (
      <div className='question-container Cards'>
        <div className='block'>
          {cards.length == 0 && <div className='block-center'><h3>{formatMessage('notFoundTrashedCards')}</h3></div>}
          {cards.length > 0 && <Pagination
            style={{marginTop: 20}}
            showSizeChanger
            onShowSizeChange={this.onShowSizeChange}
            total={cards_data.length}
            pageSizeOptions={['5', '10', '20', '50']}
            pageSize={pageSize}
            current={currentPage}
            onChange={(page, pageSize) => {
                
              this.setState({
                cards: this.paginate(this.state.cards_data, pageSize, page),
                pageSize,
                currentPage: page,
              }, () => {
                this.scrollToTop(500);
              })
            }}
          />}
            {cards.map((question, index) => <Item key={'item-question-'+ question.id} item={question} />)}
            {cards.length > 0 && <Pagination
              style={{marginTop: 20, marginBottom: 20}}
              showSizeChanger
              onShowSizeChange={this.onShowSizeChange}
              total={cards_data.length}
              pageSizeOptions={['5', '10', '20', '50']}
              pageSize={pageSize}
              current={currentPage}
              onChange={(page, pageSize) => {
                  
                this.setState({
                  cards: this.paginate(this.state.cards_data, pageSize, page),
                  pageSize,
                  currentPage: page,
                }, () => {
                  this.scrollToTop(500);
                })
              }}
            />}
						 <div style={{ float:"left", clear: "both" }}
							ref={this.refEndEl}>
						</div>
          {/* <List
            renderItem={(item) => <Item key={'card-' + item.id} item={item} />}
            dataSource={cards.map(_i => ({..._i, key: _i.id}))}
            loading={!loaded}
            pagination={{
              pageSizeOptions: ['5', '10', '20', '50'],
            }}
          /> */}
          {/* {cards.map(item => )} */}
        </div>
        
      </div>
    )
  }
}



const mapStateToProps = (state, ownProps) => ({
  // cards: state.card.list_trashed,
  // card: state.card,
  // loaded: state.card.loaded,
})

const mapDispatchToProps = {
  showModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(Cards)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/CardTrashed/components/Cards/Cards.jsx